<!--
 * @Description: 首页
 * @Version:
 * @Author: 兰双
 * @LastEditTime: 2022-03-24 14:27:04
 * @LastEditors: Please set LastEditors
 * @Date: 2021-11-25 09:39:54
-->
<template>
  <div id="home">
    <slide-container class="hei_vh" ref="slideContainer" @after="after">
      <slide-page class="hei_vh">
        <div class="banner-box hei">
          <el-carousel :interval="5000" class="hei">
            <el-carousel-item v-for="item in bannerData" :key="item.id">
              <img
                :src="item.coverPictureUrl"
                class="banner-img wid hei cursor"
                @click="jumpBaner(item)"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </slide-page>
      <slide-page class="hei_vh">
        <div class="item-box works-box hei">
          <main-title :data="worksTitle"></main-title>
          <div class="box-cont">
            <el-carousel
              indicator-position="none"
              :interval="5000"
              arrow="always"
              height="300px"
            >
              <el-carousel-item
                v-for="(item, index) in worksListData"
                :key="index"
              >
                <div class="flex-bet works-cont">
                  <div
                    v-for="val in item"
                    :key="val.id"
                    class="works-item ba_f cursor"
                    @click="jumpDetail(val, 'works')"
                  >
                    <img
                      :src="
                        !val.worksCoverPictureUrl
                          ? require('@/assets/imgs/placeImg.png')
                          : val.worksCoverPictureUrl
                      "
                      class="wid works-img"
                    />
                    <div class="works-item-tip">
                      <div class="gobyndsingle color_34">
                        {{ val.worksFileName }}
                      </div>
                      <div class="gobyndsingle company">
                        {{ val.companyName }}
                      </div>
                      <div class="works-number-box flex-bet">
                        <p>
                          <i class="iconfont icon-play color_10D1D9"></i>
                          <span>{{ val.hits }}</span>
                        </p>
                        <p>
                          <i class="iconfont icon-share color_FFA732"></i>
                          <span>{{ val.forwardCount }}</span>
                        </p>
                        <p>
                          <i class="iconfont icon-vote color_10D1D9"></i>
                          <span>{{ val.voteCount }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="t_c more-btn">
              <router-link to="/match/recommend">
                <div class="dis_in_block more color_f cursor">M O R E</div>
              </router-link>
            </div>
          </div>
        </div>
      </slide-page>
      <slide-page class="hei_vh">
        <div class="item-box match-box title_color hei">
          <main-title :data="matchTitle"></main-title>
          <div class="box-cont">
            <el-carousel
              indicator-position="none"
              arrow="always"
              height="380px"
            >
              <el-carousel-item v-for="item in matchListData" :key="item.id">
                <div
                  class="t_c match-cont cursor"
                  @click="jumpDetail(item, 'match')"
                >
                  <img
                    :src="item.coverPictureUrlPc"
                    :alt="item.title"
                    class="match-img wid"
                  />
                  <div class="color_f t_l match-item-title gobyndsingle">
                    {{ item.title }}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="t_c more-btn">
              <router-link to="/match/list">
                <div class="dis_in_block more color_f cursor">M O R E</div>
              </router-link>
            </div>
          </div>
        </div>
      </slide-page>
      <slide-page class="hei_vh">
        <div class="item-box train-box works-box hei">
          <main-title :data="trainTitle"></main-title>
          <div class="box-cont">
            <div v-if="trainListData.length > 0">
              <el-carousel
                indicator-position="none"
                :interval="5000"
                arrow="always"
                height="380px"
              >
                <el-carousel-item
                  v-for="(item, index) in trainListData"
                  :key="index"
                >
                  <div class="flex-bet train-cont">
                    <div
                      v-for="val in item"
                      :key="val.id"
                      class="train-item ba_f cursor"
                      @click="jumpDetail(val, 'train')"
                    >
                      <img :src="val.coverPictureUrlPc" class="wid train-img" />
                      <div class="train-item-tip">
                        <div class="gobyndsingle color_3 mar_t-16 mar_b-8">
                          {{ val.title }}
                        </div>
                        <div class="gobyndsingle color_9">
                          {{ val.trainingCategoryText }}
                        </div>
                        <div class="train-number-box flex-bet mar_t-16 color_6">
                          <p>
                            <i class="iconfont fon_13 icon-user color_52"></i>
                            <span>{{ val.signUpCount }}</span>
                          </p>
                          <p>
                            <i
                              class="iconfont fon_13 icon-share color_FFA732"
                            ></i>
                            <span>{{ val.forwardCount }}</span>
                          </p>
                          <p>
                            <i
                              class="iconfont fon_13 icon-show color_FFA732"
                            ></i>
                            <span>{{ val.hits }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="t_c more-btn">
                <router-link to="/train/recommend">
                  <div class="dis_in_block more color_f cursor">M O R E</div>
                </router-link>
              </div>
            </div>
            <div v-else class="t_c">
              <img
                src="@/assets/imgs/train_empty2.png"
                class="train-empty"
                alt="暂无数据"
              />
            </div>
          </div>
        </div>
      </slide-page>
      <slide-page class="hei_vh">
        <div class="item-box exchange-box title_color hei">
          <main-title :data="exchangeTitle"></main-title>
          <div class="box-cont">
            <div class="exchange-cont flex-bet">
              <div class="exchange-btn-box rel">
                <img
                  src="@/assets/imgs/exchange/topic_btn.png"
                  alt="专题"
                  class="exchange-img wid hei"
                />
                <router-link to="/exchange/topicIndex">
                  <div class="more-btn wid ab t_c">
                    <div class="dis_in_block more color_f cursor">M O R E</div>
                  </div>
                </router-link>
              </div>

              <div class="exchange-btn-box rel">
                <img
                  src="@/assets/imgs/exchange/consult_btn.png"
                  alt="咨询"
                  class="exchange-img wid hei"
                />
                <router-link to="/exchange/consultIndex">
                  <div class="more-btn wid ab t_c">
                    <div class="dis_in_block more color_f">M O R E</div>
                  </div>
                </router-link>
              </div>
              <div class="exchange-btn-box rel">
                <img
                  src="@/assets/imgs/exchange/research_btn.png"
                  alt="调研/答题"
                  class="exchange-img wid hei"
                />
                <router-link to="/exchange/surveyAnswer">
                  <div class="more-btn wid ab t_c">
                    <div class="dis_in_block more color_f">M O R E</div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </slide-page>
    </slide-container>
    <div class="instruct-box fixed">
      <div
        v-for="(item, index) in 5"
        :key="item"
        class="instruct-item flex"
        @click="jumpPage(index + 1)"
      >
        <div
          :class="[
            page == index + 1 ? 'instruct-active' : '',
            'dis_in_block instruct-circle ba_f cursor',
          ]"
        ></div>
        <div v-if="index < 4" class="instruct-line"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { SlideContainer, SlidePage } from "vue-slidepage";
import axios from "axios";
import {	global	} from "@/libs/global";
export default {
  name: "",
  mixins: [],
  components: {
    SlideContainer,
    SlidePage,
    mainTitle: () => import("@/components/match-title/index.vue"),
  },
  data() {
    return {
      pageSize: 6,
      page: 1,
      bannerData: [],
      worksTitle: {
        title: "优秀作品欣赏",
        isShowMore: false,
      },
      matchTitle: {
        title: "赛事栏目",
        isShowMore: false,
      },
      trainTitle: {
        title: "培训栏目",
        isShowMore: false,
      },
      exchangeTitle: {
        title: "交流互动",
        isShowMore: false,
      },
      worksListData: [],
      matchListData: [],
      trainListData: [],
    };
  },
async  created(){

if(this.$route.params.code){
  if(!window.localStorage.getItem('proxy')){
        // this.$confirm('是否前往用户中心?', '提示', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'info'
        //     }).then(() => {
        //       window.open('https://rz.xagh.net/')
        //     }).catch(() => {
        //     });
        window.location.href = 'https://rz.xagh.net/'
      }
      
  let res=await axios({
			headers: {'source': 2},
			method: 'post',
			url: 'https://kcapi.xagh.net/iam/login/getAccessToken',
      data: {
        code:this.$route.params.code,
        state:this.$route.params.state,
        source:2
      }
			})
      this.util.setToken(res.access_token);
      await this.getUserInfo()
      global.$emit("login");


}
  if(this.$route.query.proxy){
  window.localStorage.setItem('proxy',true)
  let res=await axios({
			headers: {
				'source': 2
			},
			method: 'post',
			url: 'https://kcapi.xagh.net/iam/login/getRedirectUri'
			})
				window.location.href = res
      }else{
        window.localStorage.removeItem('proxy')
      }
  },

  mounted() {
    this.getAdvertList();
    this.getWorksListData();
    this.getMatchListData();
    this.getTrainListData();
  },
  methods: {
          async  getUserInfo() {
            let res=await this.request.get(`${this.api.getCurrentLoginUser.request.url}`)
            this.util.setMessage("userInfo", res.sysUser);
            let userType = res.sysUser.userType;
            this.util.setMessage("userType", userType);
          },
    /**
     * @description: 获取banner数据
     * @Version:
     * @param {*}
     * @return {*}
     * @author: 兰双
     * @Date: 2021-11-25 09:52:54
     */
    async getAdvertList() {
      let data = await this.request.post(
        `${this.api.getAdvertList.request.url}`,
        {
          advertisingLocationCode: "gh_pc_index",
        }
      );
      if (data) {
        if (data.length > 0) {
          this.bannerData = data;
        }
      }
    },
    /**
     * @description: 获取推荐作品-优秀作品
     * @version: 1.0.0
     * @author: 兰双
     * @Date: 2021-11-25
     */
    async getWorksListData() {
      let data = await this.request.post(
        `${this.api.matchWorksExcellent.request.url}?pageSize=${this.pageSize}&pageNum=1`,
        {}
      );
      if (data.records.length > 0) {
        // this.worksListData = this.groupData(data.records, 3);
        let worksListData = this.groupData(data.records, 3);
        if (worksListData.length == 2) {
          this.worksListData = [
            worksListData[1],
            worksListData[0],
            worksListData[1],
            worksListData[0],
          ];
        } else {
          this.worksListData = worksListData;
        }
      }
    },
    /**
     * @description: 获取赛事列表
     * @Version:
     * @param {*}
     * @return {*}
     * @author: 兰双
     * @Date: 2021-11-25 13:46:49
     */
    async getMatchListData() {
      let data = await this.request.post(
        `${this.api.getMatchList.request.url}?pageSize=${this.pageSize}&pageNum=1`,
        {}
      );
      if (data.records.length > 0) {
        this.matchListData = data.records;
      }
    },
    async getTrainListData() {
      let data = await this.request.post(
        `${this.api.getTrainRecommendList.request.url}?pageSize=${this.pageSize}&pageNum=1`,
        {
          publishPlatform: 2,
        }
      );
      if (data) {
        data.records.map((item) => {
          item.trainingCategoryText = this.util.trainTypeText(
            item.trainingCategory
          );
        });
        this.trainListData = this.groupData(data.records, 3);
      }
    },
    /**
     * @description: 将数组分割成多个小数组
     * @Version:
     * @param {*原数组} arr
     * @param {*小数组个数} len
     * @return {*}
     * @author: 兰双
     * @Date: 2021-11-25 11:10:58
     */
    groupData(arr, len) {
      let index = 0;
      let newArr = [];
      while (index < arr.length) {
        newArr.push(arr.slice(index, (index += len)));
      }
      return newArr;
    },
    /**
     * @description: 跳转到详情
     * @Version:
     * @param {*} val
     * @param {*} type
     * @return {*}
     * @author: 兰双
     * @Date: 2021-11-25 16:06:19
     */
    jumpDetail(val, type) {
      if (type == "works") {
        let routeUrl = this.$router.resolve({
          path: "/workList_detail?id=" + val.gameSignWorksId,
        });
        window.open(routeUrl.href, "_blank");
        // this.$router.push("/workList_detail?id=" + val.gameSignWorksId);
      }
      if (type == "match") {
        let routeUrl = this.$router.resolve({
          path: "/match/detail?id=" + val.id,
        });
        window.open(routeUrl.href, "_blank");

        // this.$router.push("/match/detail?id=" + val.id);
      }
      if (type == "train") {
        if (val.trainingCategory == 0) {
          //知识技能
          let routeUrl = this.$router.resolve({
            path: "/train/knowledgeDetail?id=" + val.id,
          });
          window.open(routeUrl.href, "_blank");
          // this.$router.push("/train/knowledgeDetail?id=" + val.id);
        } else {
          let routeUrl = this.$router.resolve({
            path: "/train/courseDetail?id=" + val.id,
          });
          window.open(routeUrl.href, "_blank");
          // this.$router.push("/train/courseDetail?id=" + val.id);
        }
      }
    },
    /**
     * @description: 跳转到某一屏
     * @Version:
     * @param {*} index
     * @return {*}
     * @author: 兰双
     * @Date: 2021-11-25 16:06:19
     */
    jumpPage(index) {
      this.$refs.slideContainer.slideTo(index);
      this.page = index;
    },
    /**
     * @description: 鼠标滚动后指示灯修改
     * @Version:
     * @param {*} val
     * @param {*} target
     * @author: 兰双
     * @Date: 2021-11-25 16:06:19
     */
    after(origin, direction, target) {
      this.page = target;
    },
    /**
     * @Description:banner 跳转
     * @Version:1.0.0
     * @param {*}
     * @author 杨芳霞
     * @date 2022/2/7
     */
    jumpBaner(e) {
      if (e.linkStatus == 1) {
        if (e.linkType == 0) {
          let routeUrl = this.$router.resolve({
            path: e.linkUrl,
          });
          window.open(routeUrl.href, "_blank");
        } else {
          window.open(e.linkUrl, "_blank");
        }
      }
    },
  },
};
</script>
<style lang='scss'>
#home {
  //   height: calc(100vh - 88px);
  //   overflow-y: auto;
  img {
    object-fit: cover;
  }

  .instruct-box {
    right: 62px;
    top: 50%;
    transform: translate(-50%, -50%);

    .instruct-item {
      flex-direction: column;
      align-items: center;

      .instruct-circle {
        width: 7px;
        height: 7px;
        border-radius: 50%;
      }

      .instruct-line {
        width: 0px;
        height: 5px;
        border: 1px solid rgba(255, 255, 255, 0.8);
        margin: 7px 0;
      }

      .instruct-active {
        width: 13px;
        height: 13px;
        background: #8db3ff;
      }
    }

    .instruct-item:hover .instruct-circle {
      background: #8db3ff;
    }
  }

  .banner-box {
    .el-carousel__item,
    .el-carousel__container {
      height: 100vh;
      // height: calc(100vh - 88px);
    }
  }

  .hei_vh {
    height: 100vh;
  }
  .slide-page .wrap {
    height: 100vh;
  }

  .item-box {
    height: 100vh;
    // padding-top: 13.3vh;
    padding-top: 24vh;
    background-size: cover !important;

    .match-title {
      margin: 0 auto;
    }

    .box-cont {
      width: $max-width;
      margin: 9.2vh auto 0;

      .more-btn .more {
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        padding: 10px 20px;
        background: linear-gradient(
          180deg,
          #6b81ee 0%,
          #3177db 51%,
          #152da7 100%
        );
        border-radius: 26px;
      }

      .more-btn .more:hover {
        background: linear-gradient(
          180deg,
          #a7b5f9 0%,
          #6fa2e9 51%,
          #485cc1 100%
        );
      }
    }

    .el-carousel__arrow i {
      font-size: 16px;
    }
  }

  .title_color {
    .title {
      color: #fff;

      .title-en {
        opacity: 0.49;
      }
    }
  }

  .works-box {
    background: url("~@/assets/imgs/works_bgk2.jpg") no-repeat center;

    .el-carousel__arrow {
      background: #fff;
      color: #707070;
    }

    .el-carousel__arrow:hover {
      background: #456fe4;
      color: #fff;
    }

    .works-cont {
      padding: 0 100px;

      .works-item {
        width: 304px;
        border-radius: 14px;
        overflow: hidden;

        .works-img {
          height: 171px;
        }

        .works-item-tip {
          padding: 10px 14px;

          .company {
            margin: 3px 0 13px;
            color: #8d8d8d;
          }

          .works-number-box {
            border-top: 1px solid #f5f5f5;
            padding-top: 9px;
          }
        }
      }
    }

    .more-btn {
      margin-top: 10.2vh;
    }
  }

  .match-box {
    background: url("~@/assets/imgs/match_bgk2.png") no-repeat center;

    .box-cont {
      padding: 0 30px;

      .match-cont {
        width: 590px;
        margin: 0 auto;

        .match-img {
          height: 332px;
          border-radius: 20px;
        }

        .match-item-title {
          padding: 13px 27px 0;
        }
      }

      .el-carousel__arrow {
        background: rgba(255, 255, 255, 0.7);
        color: #707070;
      }

      .el-carousel__arrow:hover {
        color: #456fe4;
        background: #fff;
      }
    }

    .more-btn {
      margin-top: 3vh;
    }
  }

  .train-box {
    background: url("~@/assets/imgs/train_bgk2.jpg") no-repeat center;

    .train-cont {
      padding: 0 80px;

      .train-item {
        width: 334px;
        padding: 52px 16px 22px;
        border-radius: 20px;

        .train-img {
          height: 171px;
          box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.16);
          border-radius: 20px;
        }

        .iconfont {
          margin-right: 3px;
        }
      }
    }

    .more-btn {
      margin-top: 6vh;
    }

    .train-empty {
      width: 505px;
    }
  }

  .exchange-box {
    background: url("~@/assets/imgs/exchange_bgk2.png") no-repeat center;

    .box-cont {
      .exchange-cont {
        padding: 0 90px;

        .exchange-btn-box {
          width: 267px;
          height: 322px;

          .more-btn {
            bottom: 40px;
            z-index: 10;

            .more {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
